import React, { useEffect } from 'react';
import { Col, Container,  Row, } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { 
  getCredit as onGetCredit,
} from 'slices/dashboard/thunk';
import TransactionsTable from './TransactionsTable';



const Transactions = () => {

  document.title = "Transactions | WeReload";

  const dispatch = useDispatch();

  useEffect(() => {
    // @ts-ignore
    dispatch(onGetCredit());
  }, [dispatch])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col lg={12}>
              <TransactionsTable />
            </Col>
          </Row>
        </Container>
      </div >
    </React.Fragment >
  );
}

export default Transactions;